module.exports = __webpack_public_path__ + "img/reserved.d05b8c2d.svg";